import { PlatformEnum } from '../types/enums';
import { getOffsetLimitFromPagination, getQueryString } from '../utils/query';
import { PagedRequestArgs, PagedResponse } from '../utils/types';
import { callApi } from './api';

export type Values = {
  name: string;
  type: 'str' | 'bool';
  multi?: boolean;
  values?: string[];
};

// `attributes` is optional: permissions seeded before the schema existed can
// carry params in another shape.
export type Attribute = { attributes?: Values[] };

export type PermissionMR = {
  id: number;
  name: string;
  params?: Attribute;
  platform: PlatformEnum;
};

export type PermissionUsageMR = PermissionMR & {
  roleCount: number;
  // Permissions IAM reads by name to authorize its own routes; the API refuses
  // to change or delete them.
  isProtected: boolean;
};

export type PermissionC = {
  name: string;
  platform: PlatformEnum;
  params?: Attribute | null;
};

// Name and platform are immutable: apps check permissions by name, so a rename
// breaks them silently.
export type PermissionU = {
  params?: Attribute | null;
};

class PermissionsService {
  async getAll(): Promise<PermissionMR[]> {
    return callApi({ url: '/permissions/' });
  }

  async getPaged({
    page,
    size,
    cancelToken,
    searchValue
  }: PagedRequestArgs & { searchValue: string }): Promise<PagedResponse<PermissionUsageMR>> {
    const query = getQueryString({ ...getOffsetLimitFromPagination({ page, size }), search: searchValue });
    return callApi({ url: `/permissions/?${query}`, cancelToken });
  }

  async add(data: PermissionC) {
    return callApi({ url: '/permissions/', method: 'POST', data });
  }

  async edit(id: number, data: PermissionU) {
    return callApi({ url: `/permissions/${id}/`, method: 'PUT', data });
  }

  async remove(id: number) {
    return callApi({ url: `/permissions/${id}/`, method: 'DELETE' });
  }
}

export const permissionsService = new PermissionsService();
